module.exports = __webpack_public_path__ + "static/media/FibonacciRabbit.a7796049.svg";